export default {
    ABERTO: 'Aberto',
    AGUARDANDO_ABERTURA: 'Aguardando Abertura',
    ENCERRADO: 'Encerrada',
    SUSPENSO: 'Suspenso'
}
